import app_logo from 'assets/app_logo.png'
import welcome from 'assets/welcome.png';
import { LoginForm } from 'features/auth/components';
export const LoginView = () => {
  return (
    <div className="flex min-h-screen">
      {/* Left Side: Login Form */}
      {/* <div className="absolute top-10 left-10 text-black">
        <hr className="mt-2 w-24 border-gray-300" />
      </div> */}
      <div className="w-full md:w-1/2 flex items-start pt-8 justify-center bg-white">
        <div className="w-full  max-w-lg p-10">
         <img src={app_logo} alt='logo' width={300} height='auto' className='mb-5 '/>
          <div className="mb-6 text-left">
            <h3 className="text-xl font-bold text-gray-800">Login</h3>
          </div>
          <div className="bg-gray-50 shadow-lg rounded-lg p-8 py-10 w-full">
            <LoginForm />
          </div>
        </div>
      </div>


      {/* Right Side: Image */}
      <div className="w-1/2 hidden md:flex items-center justify-center bg-gray-100">
        <img src={welcome} alt="Welcome" className="w-full h-full object-cover -scale-x-100" />
      </div>
    </div>
  );
};
